"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isEqual_1 = __importDefault(require("lodash/isEqual"));
function useDeepComparisonMemoize(react, value) {
    const ref = react.useRef();
    if (!(0, isEqual_1.default)(value, ref.current)) {
        ref.current = value;
    }
    return ref.current;
}
exports.default = useDeepComparisonMemoize;
